import { Link } from 'react-router-dom'

import { t } from '../i18n'
import { Notice } from '../ui'

/**
 * What a URL naming a job this person cannot open draws.
 *
 * The shell resolves the project id in the address against the placements
 * `GET /session/me` answered. When there is no placement for it the shell used
 * to redirect to `/`. That was already the second version of this: before #254
 * it went to the first job the person held, which put a reader following a
 * stale link to one site on another site's overview with nothing saying so.
 * The redirect to the chooser stopped opening the wrong job, and kept the rest
 * of the fault — the address was still discarded without a word, so a typo, a
 * job that closed, and a link to somebody else's job all looked like "the list
 * just appeared". Found in the owner's browser walk of the deployed alpha on
 * #289.
 *
 * This renders in place instead. The address in the bar is the one that was
 * asked for, and the page says what happened to it.
 *
 * **It takes no props and reads no params, and that is the security property
 * rather than a simplification.** A project of another customer has to be
 * answered exactly as a project that does not exist is answered: the API makes
 * them indistinguishable, and a screen that varied — different words, a
 * different shape, the id echoed back — would hand that difference to
 * anybody holding a session, who could then find out which project ids are
 * real by typing them. There is nothing here for the id to change, so the two
 * cases cannot drift apart later either. The chooser makes the same argument
 * for itself in `Projects.tsx`, and this is the other half of it.
 *
 * The same answer covers an expired membership and a job somebody was taken
 * off, which is why the text sends them to whoever administers the job rather
 * than implying the address was a typo.
 */
export function UnavailableProject() {
  return (
    <div className="signin">
      <h2 className="page">{t('app.unavailable_project')}</h2>
      <Notice tone="warn">
        <div className="muted">{t('app.unavailable_project_body')}</div>
      </Notice>
      <p>
        <Link to="/">{t('app.unavailable_project_back')}</Link>
      </p>
    </div>
  )
}
